import { HTTP } from '@/http';

export default class DepositService {

  deposit(model) {
    return HTTP.post(`deposits`, model);
  }

  getPSPList() {
    return HTTP.get(`deposits/psp`);
  }

  getTransaction(configId, transactionId) {
    return HTTP.get('transactions/' + configId + '/' + transactionId);
  }

  getViewValidationMessage() {
    return HTTP.get('deposits/view/validation');
  }
}





// WEBPACK FOOTER //
// ./src/services/DepositService.js